import { r } from '@/plugins/resource/resource'
import { queryPostfix as q } from '@/plugins/resource/api'

const MODEL = 'payment-calculator'
const CONFIGURATIONS_MODEL = `${MODEL}/configurations`

const configQuery = ['location_country_id', 'target_country_id', 'category_id', 'offer_id']
const additionalQuery = [...configQuery, 'financing_type', 'search']
const rootCategoriesQuery = [...additionalQuery, 'is_root']

export const paymentCalculatorApi = {
  categoriesList: r(
    q('/categories/list/', rootCategoriesQuery),
    CONFIGURATIONS_MODEL
  ),
  countriesLocationList: r(
    q('/countries/location/list/', additionalQuery),
    CONFIGURATIONS_MODEL
  ),
  countriesTargetList: r(
    q('/countries/target/list/', additionalQuery),
    CONFIGURATIONS_MODEL
  ),
  financingInfo: r('/financing-info/', CONFIGURATIONS_MODEL),
  configs: r(q('/list/', configQuery), CONFIGURATIONS_MODEL),
  defaultConfigs: r(q('/list/for-offer/', configQuery), CONFIGURATIONS_MODEL),
}
